module.exports = __webpack_public_path__ + "img/user-lock.4e1e94bf.svg";